import { Row } from '@unistocks/components/layout/flex';
import { getGenericColumn } from '@unistocks/features/portfolios/components/portfolio-table/utils';
import { useTableColumns } from '@unistocks/features/portfolios/hooks/use-table-columns';
import { isPortfolio } from '@unistocks/features/portfolios/portfolio-utils';
import { useMedia, View, ViewProps } from 'tamagui';
import { TableFooterCell } from './table-cell';
import { PortfolioTableColumn, TableSectionProps } from './types';

export type TableSectionFooterProps = TableSectionProps & ViewProps;

export const TableSectionFooter: React.FC<TableSectionFooterProps> = ({ portfolio, section }) => {
  const { isReadonly } = portfolio;
  const media = useMedia();
  const { selected: selectedColumns } = useTableColumns(portfolio);

  return (
    <Row
      alignItems={'center'}
      bg={'$color4'}
      px={'$2'}
      py={'$1'}
      gap={0}
      bblr={'$2'}
      bbrr={'$2'}
      $md={{ px: '$3', py: '$2' }}
    >
      {isPortfolio(portfolio) ? (
        <>
          <View w={'$2.5'} display="none" $md={{ display: 'block', mr: '$3' }} />
          <TableFooterCell column={nameCol} section={section} portfolio={portfolio} />
          {selectedColumns.map(column => (
            <TableFooterCell
              key={column.prop}
              column={column}
              section={section}
              portfolio={portfolio}
            />
          ))}
          {media.lg && !isReadonly ? (
            <TableFooterCell
              column={settingsCol}
              section={section}
              portfolio={portfolio}
              w={'$1.5'}
              ml={'$3'}
            />
          ) : null}
        </>
      ) : null}
    </Row>
  );
};

const nameCol = getGenericColumn('name');
const settingsCol: PortfolioTableColumn = {
  prop: 'settings',
  displayName: ''
};

TableSectionFooter.displayName = 'TableSectionFooter';
